import { baseApi } from "./baseApi";

const PUBLIC_BASE_URL = "/public";

export const publicApi = baseApi.injectEndpoints({
  tagTypes: ["Public"],

  endpoints: (builder) => ({
    getPublicAccountList: builder.query({
      query: () => `${PUBLIC_BASE_URL}/accounts/list`,
    }),

    getPublicAccountEntities: builder.query({
      query: (accountId) =>
        `${PUBLIC_BASE_URL}/accounts/${accountId}/entities/list`,
    }),

    getPublicListOptions: builder.query({
      query: (params) => ({ url: `${PUBLIC_BASE_URL}/list-options`, params }),
    }),

    getCountryLevel: builder.query({
      query: (params) => ({
        url: `${PUBLIC_BASE_URL}/country-level`,
        params,
      }),
    }),

    getPublicAddressByName: builder.query({
      query: (name) => `${PUBLIC_BASE_URL}/maps/${name}`,
    }),

    // getShipmentStatus: builder.query({
    //   query: ({ shipmentId }) => `${PUBLIC_BASE_URL}/tracking/${shipmentId}`,
    // }),

    // Update the listBlogs endpoint
    listBlogs: builder.query({
      query: (params) => ({
        url: `${PUBLIC_BASE_URL}/blogs`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ slug }) => ({ type: "Blog", slug })),
            { type: "Blog", id: "LIST" },
          ]
          : [{ type: "Blog", id: "LIST" }],
    }),

    // Fetch blog details by ID
    getBlogDetails: builder.query({
      query: (slug) => ({
        url: `${PUBLIC_BASE_URL}/blogs/${slug}`,
      }),
      providesTags: (result, error, id) => [{ type: "Blog", _id: id }],
    }),

    getBlogCategories: builder.query({
      query: () => `${PUBLIC_BASE_URL}/blog-categories`,
      providesTags: ["BlogCategories"],
    }),

    // getShipmentStatus: builder.query({
    //   query: (params) => ({
    //   url:`${PUBLIC_BASE_URL}/tracking`,
    //   params,
    //   }),
    // }),

    //  getShipmentById: builder.query({
    //   query: (id) => ({
    //     url: `${PUBLIC_BASE_URL}/tracking/${id}`,
    //   }),

    // }),

    getShipmentStatus: builder.query({
      query: (params) => ({
        url: `${PUBLIC_BASE_URL}/tracking`,
        params: {
          shipmentId: params.shipmentId,
          reference: params.reference,
        },
      }),
      providesTags: ["Shipment"],
    }),

    getDDLRoutesShipments: builder.query({
      query: (params) => ({
        url: `${PUBLIC_BASE_URL}/routeddl`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({ type: "RouteShipment", id: _id })),
            { type: "RouteShipment", id: "DDL" },
          ]
          : [{ type: "RouteShipment", id: "DDL" }],
    }),

getRouteDepartureETA: builder.query({
  query: (routeId) => `${PUBLIC_BASE_URL}/eta?routeId=${routeId}`,
  providesTags: (result, error, routeId) => [
    { type: "RouteDepartureETA", id: routeId },
  ],
}),

    getShipmentById: builder.query({
      query: (id) => ({
        url: `${PUBLIC_BASE_URL}/tracking/${id}`,
      }),
    }),
  }),
});

export const {

  useGetPublicAccountListQuery,
  useLazyGetPublicAccountEntitiesQuery,

  useGetPublicListOptionsQuery,
  useLazyGetPublicListOptionsQuery,

  useLazyGetPublicLocationUniversitiesQuery,


  useGetCountryLevelQuery,
  useLazyGetCountryLevelQuery,

  useLazyGetPublicAddressByNameQuery,

  // shipment tracking
  useLazyGetShipmentStatusQuery,
  useGetShipmentStatusQuery,
  useGetShipmentByIdQuery,
  useLazyGetShipmentByIdQuery,
  // blogs
  useLazyListBlogsQuery,
  useListBlogsQuery,

  useGetBlogDetailsQuery,
  useGetBlogCategoriesQuery,

  useLazyGetRouteDepartureETAQuery,
  useGetRouteDepartureETAQuery,

  useLazyGetDDLRoutesShipmentsQuery,

} = publicApi;
